@if (t.testMode()) {
  <p-panel class="ces-panel" [toggleable]="true" [collapsed]="true" toggler="header">
    <ng-template #header>
      <div class="cursor-pointer flex flex-row items-center gap-(--gap-tight)">
        <span>{{ title || 'Form Debug' }}</span>
        <span class="text-(color:--text-secondary) ml-(--space-1)">(</span>
        <div class="text-xs inline">
          @if (form?.pristine) {
            <span class="status-item">Pristine</span>
          }
          @if (form?.dirty) {
            <span class="status-item">Dirty</span>
          }
          @if (form?.touched) {
            <span class="status-item">Touched</span>
          }
          @if (!form?.touched) {
            <span class="status-item">Untouched</span>
          }
          @if (form?.valid) {
            <span class="status-item green">Valid</span>
          }
          @if (!form?.valid) {
            <span class="status-item red">Invalid</span>
          }
          @if (form?.pending) {
            <span class="status-item orange">Pending</span>
          }
          @if (form?.disabled) {
            <span class="status-item gray">Disabled</span>
          }
        </div>
        <span class="text-(color:--text-secondary)">)</span>
      </div>
    </ng-template>

    @if (form) {
      <div class="text-xs">
        <p-tabView>
          <!-- Vue générale -->
          <p-tabPanel header="Vue générale">
            <div class="flex flex-col gap-(--gap-tight)">
              <div class="debug-properties">
                <div class="property-row">
                  <span class="property-label">Status:</span>
                  <span
                    [ngClass]="{
                      green: form.status === 'VALID',
                      red: form.status === 'INVALID',
                      orange: form.status === 'PENDING',
                      gray: form.status === 'DISABLED',
                    }"
                    >{{ form.status }}</span
                  >
                </div>
                <div class="property-row">
                  <span class="property-label">Pristine:</span>
                  <span>{{ form.pristine }}</span>
                </div>
                <div class="property-row">
                  <span class="property-label">Dirty:</span>
                  <span>{{ form.dirty }}</span>
                </div>
                <div class="property-row">
                  <span class="property-label">Touched:</span>
                  <span>{{ form.touched }}</span>
                </div>
                <div class="property-row">
                  <span class="property-label">Pending:</span>
                  <span>{{ form.pending }}</span>
                </div>
                <div class="property-row">
                  <span class="property-label">Erreurs au niveau du formulaire:</span>
                  <span>{{ formLevelErrors | json }}</span>
                </div>
              </div>
            </div>
          </p-tabPanel>

          <!-- Contrôles -->
          <p-tabPanel header="Contrôles">
            <div class="overflow-auto max-h-96">
              <p-table [value]="controlsList" [tableStyle]="{ 'min-width': '50rem' }" styleClass="text-xs">
                <ng-template pTemplate="header">
                  <tr>
                    <th>Nom</th>
                    <th>Valeur</th>
                    <th>Status</th>
                    <th>Dirty</th>
                    <th>Touched</th>
                    <th>Erreurs</th>
                  </tr>
                </ng-template>
                <ng-template pTemplate="body" let-control>
                  <tr [ngClass]="{ 'invalid-row': control.invalid, 'disabled-row': control.disabled }">
                    <td>{{ control.name }}</td>
                    <td class="truncate max-w-xs" [pTooltip]="getValueTooltip(control.value)">
                      {{ getDisplayValue(control.value) }}
                    </td>
                    <td
                      [ngClass]="{
                        green: control.status === 'VALID',
                        red: control.status === 'INVALID',
                        orange: control.status === 'PENDING',
                        gray: control.status === 'DISABLED',
                      }">
                      {{ control.status }}
                    </td>
                    <td>{{ control.dirty }}</td>
                    <td>{{ control.touched }}</td>
                    <td class="truncate max-w-xs" [pTooltip]="control.errors | json">
                      {{ control.errors | json }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </p-tabPanel>

          <!-- Valeurs -->
          <p-tabPanel header="Valeurs">
            <div class="form-value">
              <pre>{{ formValue | json }}</pre>
            </div>
          </p-tabPanel>

          <!-- Validations -->
          <p-tabPanel header="Validations">
            @if (allErrors.length === 0) {
              <div class="green">Aucune erreur</div>
            }
            @if (allErrors.length > 0) {
              <div class="overflow-auto max-h-96">
                <p-table [value]="allErrors" [tableStyle]="{ 'min-width': '50rem' }" styleClass="text-xs">
                  <ng-template pTemplate="header">
                    <tr>
                      <th>Champ</th>
                      <th>Type d'erreur</th>
                      <th>Détails</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-error>
                    <tr>
                      <td>{{ error.controlName }}</td>
                      <td>{{ error.errorType }}</td>
                      <td>{{ error.details | json }}</td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            }
          </p-tabPanel>

          <!-- Structure -->
          <p-tabPanel header="Structure">
            <div class="form-structure">
              <pre>{{ formStructure }}</pre>
            </div>
          </p-tabPanel>
        </p-tabView>
      </div>
    }

    @if (!form) {
      <div class="text-xs red">Aucun formulaire fourni</div>
    }
  </p-panel>
}
